export default __webpack_public_path__ + "static/media/Certificate of Registration with Seal NPC.f11578e2.svg";